export const FACT_INPUT_NAME_REGEX = /RULE-(.+)-FACT-(.+)/
export const DOT_REPLACEMENT_REGEX = /@DOT@/g
